<div class="modal-header">
    <h4 class="modal-title">{{ isEdit ? 'Editar' : 'Agregar' }}  SKU de planta</h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<div class="modal-body">
    <mat-dialog-content>
        <div class="row">
            <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>SKU</mat-label>
                    <input matInput required [(ngModel)]="sku_planta">
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Planta</mat-label>
                    <input [(ngModel)]="planta" type="search" name="focus" class="form-control search-input" [value]="searchQuery" matInput  [matAutocomplete]="searchAutoComplete" (input)="doSearch($event)">
                    <mat-autocomplete #searchAutoComplete="matAutocomplete">
                        <mat-option *ngFor="let result of plantaSearchList" [value]="result.planta" (onSelectionChange)="onResultSelection(result.planta)">
                        {{result.planta}}
                        </mat-option>
                    </mat-autocomplete> 
                </mat-form-field>
            </div>
            
        </div>


      </mat-dialog-content>
</div>
<div class="modal-footer mt-3">
    <button mat-flat-button class="bg-primary text-white" (click)="agregarSKU()">{{ isEdit ? 'Guardar' : 'Agregar' }}</button>
</div>
